// extracted by mini-css-extract-plugin
export default {"content__wrapper":"styles_content__wrapper__NVVrW"};